// removed by extract-text-webpack-plugin
module.exports = {"root":"_3wuAU","title":"_1Z4nL","description":"_3PIdA","infoBlock":"_cKanO","dot":"_2lp4-"};


//////////////////
// WEBPACK FOOTER
// ./app/components/PostCard/PostCard.scss
// module id = 1112
// module chunks = 1